import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const IntegrationPreview = (props) => {
    const content = (React.createElement(Preview, null,
        React.createElement(Logo, { src: props.integration.logo }),
        React.createElement(Meta, null,
            React.createElement(Title, null, props.integration.name),
            React.createElement(Description, null, props.integration.shortDescription))));
    return (React.createElement(Wrapper, null, props.href ? React.createElement(ALink, { to: props.href }, content) : content));
};
const Wrapper = styled.div `
  transition: box-shadow 200ms ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px;
  @media (min-width: 560px) {
    width: calc(50% - 20px);
  }
  @media (min-width: 1160px) {
    width: calc(33.3333333% - 20px);
  }
  @media (min-width: 1500px) {
    width: calc(25% - 20px);
  }
  :hover {
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.1);
  }
`;
const ALink = styled(Link) `
  text-decoration: none;
  color: inherit;
`;
const Preview = styled.div `
  text-decoration: none;
`;
const Logo = styled.img `
  width: 100%;
  height: 64px;
  object-fit: contain;
  padding: 10px;
`;
const Meta = styled.div `
  padding: 10px;
`;
const Title = styled.h2 `
  margin: 0;
`;
const Description = styled.p `
  margin: 0;
`;
export default IntegrationPreview;
//# sourceMappingURL=IntegrationPreview.js.map